import React from "react";
import IncomeBasic from "./IncomeBasic";

/**
 * Basic-only wrapper.
 * Advanced now lives in separate sections, so this component
 * renders only the Basic income UI with no internal tab switcher.
 *
 * All props (including `dataKey`) are forwarded so this wrapper
 * can be reused for "income", "income_assessor", and "income_actuals".
 */
export default function IncomeSection(props) {
  return <IncomeBasic {...props} />;
}
